import { useContext } from "react";
import { JourneysContext } from "../../context/journeys-context";
import JourneysConstituentList from "./contact-table/journeys-constituents-list";
import JourneysTaskTable from "./task-table/journeys-task-table";

const JourneysDashboard = () => {
  const { onStageWithTable } = useContext(JourneysContext);

  return <>{onStageWithTable ? <JourneysConstituentList /> : <JourneysTaskTable />}</>;
};

export default JourneysDashboard;
